import { render } from "./WidgetTiles.vue?vue&type=template&id=6db6b7c6&scoped=true"
import script from "./WidgetTiles.vue?vue&type=script&lang=js"
export * from "./WidgetTiles.vue?vue&type=script&lang=js"

import "./WidgetTiles.vue?vue&type=style&index=0&id=6db6b7c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db6b7c6"]])

export default __exports__